import React from 'react';

import { useCalibrationScoreSettings, useReviewCreationData } from 'reducers/reviewCreationSlice';

import { useGetCalibrationSettings, useSaveCalibrationSettings } from '../../Hooks/dataHooks/calibrationDataHooks';
import { ReviewCreationFooter } from '../../ReviewCreationFooter';
import { SkeletonLoaderMultiViewVariant } from '../../components/SkeletonLoaderReviewCreation';
import { PerformanceGrid } from './PerformanceGrid';
import { AnswerTypes, ScoreSection } from './ScoreSection';
import { isScoreNameValid, isScoreValidator } from './TextScoreSettingTable';

const Footer = () => {
  const { answerOptions, answerType } = useCalibrationScoreSettings();
  let isValidScoreSettings = false;
  if (answerType === AnswerTypes.NUMBER_RATING) {
    // because we have fixed options in dropdown
    isValidScoreSettings = true;
  } else {
    const isValidScoreNames = isScoreNameValid(answerOptions);
    const isScoreValid = isScoreValidator(answerOptions);
    isValidScoreSettings = isValidScoreNames && isScoreValid;
  }

  // const {} = useGridDefinition();
  const saveDataMutation = useSaveCalibrationSettings();

  const isContinueDisabled = !isValidScoreSettings || saveDataMutation.isLoading;

  const handleContinue = () => {
    saveDataMutation.mutate();
  };

  return <ReviewCreationFooter isContinueDisabled={isContinueDisabled} onContinue={handleContinue} />;
};

const Calibration = () => {
  const { reviewCycleId } = useReviewCreationData();

  const { isSuccess, isLoading } = useGetCalibrationSettings({ reviewCycleId });

  if (isLoading) {
    return <SkeletonLoaderMultiViewVariant />;
  }

  if (!isSuccess) return null;

  return (
    <>
      <ScoreSection />
      <PerformanceGrid />

      <Footer />
    </>
  );
};

export { Calibration };
